import { INavItem } from "../types";
import { PostsNavLink } from "./constants";

export const navlinks: INavItem = {
  path: `/${PostsNavLink}`,
  name: 'Posts',
  icon: 'TableChartOutlinedIcon',
  title: 'posts',
};
